import {
  BaseQueryFn,
  EndpointBuilder,
  InfiniteQueryDefinition,
} from "@reduxjs/toolkit/query";

import { getWorkspace } from "@/utils/helpers";

export const createInfiniteQuery = <TData>(
  builder: EndpointBuilder<BaseQueryFn, string, string>,
  endpoint: string,
  tags: string[],
  keepUnusedDataFor?: number,
): InfiniteQueryDefinition<
  string | undefined,
  {
    offset: number;
    limit: number;
    filter?: string;
  },
  BaseQueryFn,
  string,
  GeneralResponse<TData>,
  string
> => {
  return builder.infiniteQuery<
    GeneralResponse<TData>,
    string | undefined,
    { offset: number; limit: number; filter?: string }
  >({
    infiniteQueryOptions: {
      initialPageParam: { offset: 0, limit: 20, filter: "" },

      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const nextOffset = lastPageParam.offset + lastPageParam.limit;
        const remainingItems = lastPage?.pagination?.totalResult - nextOffset;

        return remainingItems > 0
          ? { ...lastPageParam, offset: nextOffset }
          : undefined;
      },
      getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => {
        const prevOffset = firstPageParam.offset - firstPageParam.limit;

        return prevOffset >= 0
          ? { ...firstPageParam, offset: prevOffset }
          : undefined;
      },
    },
    ...(keepUnusedDataFor && { keepUnusedDataFor }),
    query: ({ pageParam: { offset, limit }, queryArg }) => {
      //Temp fix for undefined
      const finalEndpoint = endpoint.includes("workspace/undefined")
        ? endpoint.replace("workspace/undefined", `workspace/${getWorkspace()}`)
        : endpoint;

      if (queryArg) {
        return `${finalEndpoint}?offset=${offset}&limit=${limit}&${queryArg}`;
      }

      return `${finalEndpoint}?offset=${offset}&limit=${limit}`;
    },

    providesTags: tags,
  });
};
